const apiRoot = process.env.REACT_APP_Back_end_api_root;

/* glodal endpoint */
export const uploadOneImageUrl = `${apiRoot}/uploadOneImage/`; /* folderName/:imageName */
export const pingUrl = `${apiRoot}/ping`;

/* user */
export const signUpURL = `${apiRoot}/signUp`;
export const signInURL = `${apiRoot}/signIn`;
export const resetPasswordUrl = `${apiRoot}/signIn/resetPassword`;
// verify email
export const verifyEmailURL = `${apiRoot}/signUp/verifyEmail`; /* + :userID + access token required */

export const editProfileURL = `${apiRoot}/settings/editProfile`;
export const subscriptionURL = `${apiRoot}/settings/subscribe`;
export const cancelSubscriptionURL = `${apiRoot}/settings/subscribe/cancel`;
export const freeSubscriptionUrl = `${apiRoot}/settings/subscribe/freeSubscription`;
export const startStarterPlanUrl = `${apiRoot}/settings/subscribe/starterPlan`;

/* webstore user profile */
export const withdrawReferralBonusPayoutUrl = `${apiRoot}/referrals/requestWithdrawal/`;
export const fetchReferralInfoUrl = `${apiRoot}/referrals`;
export const uploadWebstoreImageUrl = `${apiRoot}/settings/editProfile/uploadWebstoreUserImage`;

export const changePasswordURL = `${apiRoot}/settings/editProfile/changePassword`;

/* store */
export const createStoreUrl = `${apiRoot}/stores/createStore`;
export const updateStorePublicityUrl = `${apiRoot}/stores/createStore/updateStorePublicity/`; /* + storeID */
export const uploadStoreImageUrl = `${apiRoot}/stores/createStore/uploadStoreImage`;
export const updateStoreModeUrl = `${apiRoot}/stores/createStore/updateStoreMode/`; /* + storeID */
export const updateStoreImageUrl = `${apiRoot}/stores/createStore/updateStoreImage/`; /* + storeID */
export const updateStoreTargetUrl = `${apiRoot}/stores/createStore/updateStoreTargets/`; /* + storeID */
export const getStoreUrl = `${apiRoot}/stores/fetchStore/`; /* + storeID */
export const updateStoreOpeningHours = `${apiRoot}/stores/
createStore/updateStoreOpeningHours/`; /* + storeID */
export const storeReceivingAccountUrl = `${apiRoot}/stores/createStore/storeReceivingAccount/`; /* + storeID */

export const updateStoreVatUrl = `${apiRoot}/stores/createStore/updateStoreVat/`; /* + storeID */

export const addExpensesUrl = `${apiRoot}/stores/expenses/createExpenses/`; /* + storeID */
export const getStoreExpensesUrl = `${apiRoot}/stores/expenses/getExpenses/`; /* + storeID */
export const getStoreExpensebyMonthUrl = `${apiRoot}/stores/expenses/getExpenses/`; /* + storeID/+ month number (0-11) */

/* warehouse */

export const addProductToWarehouseUrl = `${apiRoot}/warehouse/addProductToWarehouse/`; /* + warehouseID */
export const addBulkProductToWarehouseUrl = `${apiRoot}/warehouse/bulkAddProductToWarehouse/`; /* + warehouseID */
export const getWarehouseUrl = `${apiRoot}/warehouse/getWarehouse/`; /* + warehouseID */
export const moveToStoreUrl = `${apiRoot}/warehouse/moveToStore/`; /* + warehouseID */
export const deleteWarehouseUrl = `${apiRoot}/warehouse/deleteWareHouse/`; /* + warehouseID */
export const restockWarehouseProductUrl = `${apiRoot}/warehouse/restockWarehouseProduct/`; /* + warehouseID */
export const editproductInWarehouseUrl = `${apiRoot}/warehouse/editWarehouseProduct/`; /* + warehouseID */ // ?type=delete || update

/* customers */
export const deleteCustomeUrl = `${apiRoot}/customers/deleteCustomer/`; /* + customerID */
export const fetchCustomerUrl = `${apiRoot}/customers/getAllCustomers/`;
export const sendEmailCampaignUrl = `${apiRoot}/customers/sendEmailCampaign/`; /* + storeID */

/* employee */
export const uploadEmployeeImageUrl = `${apiRoot}/employee/uploadImage`;
export const createEmployeeUrl = `${apiRoot}/employee/createEmployee/`;
export const fetchAllEmployees = `${apiRoot}/employee/fetchAllEmployees/`;
export const editEmployeeUrl = `${apiRoot}/employee/editEmployee/`; /* + employeeID */

export const sendLoginDetailsUrl = `${apiRoot}/employee/sendLoginDetails/`; /* {employee} */
export const deleteEmployeeUrl = `${apiRoot}/employee/deleteEmployee/`; /* + employeeID */
export const fetchEmployeeHistoryUrl = `${apiRoot}/employee/fetchEmployeeHistory/`; /* + staffID + ?page & limit */

/* product */
export const uploadProductImageUrl = `${apiRoot}/stores/createProduct/uploadProductImage`;
export const createProductUrl = `${apiRoot}/stores/createProduct/`; /* + storeID */ /* route use also to fetch storeProduct collection */
export const fetchProductForUserUrl = `${apiRoot}/stores/createProduct/fetchProductForUser`; /*fetch all user products ? /:userID/?pages&limit */
//export all product for user
export const exportAllUserProductsUrl = `${apiRoot}/stores/createProduct/exportAllUserProducts`;

export const fetchAProductUrl = `${apiRoot}/stores/createProduct/fetchProduct/`; /* + productID*/ /* route use also to fetch sing product */
//product movement to store and warhouse
export const moveStoreToStoreUrl = `${apiRoot}/stores/createProduct/moveToStore/`; /* + sourceStoreID */
export const moveStoreToWarehouseUrl = `${apiRoot}/stores/createProduct/moveToWarehouse/`; /* + sourceStoreID */

export const addSalesUrl = `${apiRoot}/stores/createProduct/addSales/2/`; /* + storeID */
export const AddDamagesUrl = `${apiRoot}/stores/createProduct/addDamages/2/`; /* + storeID */
export const restockProductUrl = `${apiRoot}/stores/createProduct/restock/`; /* + storeID */
export const confirmPasswordUrl = `${apiRoot}/stores/createProduct/confirmPassword/`; /* + storeID */
export const editProductUrl = `${apiRoot}/stores/createProduct/editProduct/`; /* + storeID method Patch */
export const getProductHistoryUrl = `${apiRoot}/stores/createProduct/getProductHistory/`; /* + storeID + productID /?year,month,allTime,page,limit */
export const getProductCatelogFromImageUrl = `${apiRoot}/stores/createProduct/getProductCatelogFromImage/`; /* + storeID */
export const bulkProductCreateUrl = `${apiRoot}/stores/createProduct/bulkUpload/`; /* + storeID */
export const hasSeenPromptsSubUnitUrl = `${apiRoot}/stores/createProduct/hasSeenPromptsSubUnit/`; // + storeID + productID

export const updateSubUnitUrl = `${apiRoot}/stores/createProduct/updateSubUnits/`; // + storeID + productID
export const updateEachSubUnitUrl = `${apiRoot}/stores/createProduct/updateEachSubUnit/`; // + storeID + productID/?type=delete||update

/* transaction route */
export const deleteTransactionUrl = `${apiRoot}/stores/transactions/deleteTransaction/`; /* + storeID + transactionID */
export const createTransactionUrl = `${apiRoot}/stores/transactions/createATransaction/`; /* + storeID */

export const fetchStoreTransactionUrl = `${apiRoot}/stores/transactions/getTodaysTransactions/`; /* + storeID */

export const fetchUsersTransactionUrl = `${apiRoot}/stores/transactions/getAllTransactions/`; /* + WebstoreUserID */

export const fetchCustomerTransactionsUrl = `${apiRoot}/stores/transactions/customerTransactions/`; /* + storeID + customerID*/

//push payment KUDA integration
export const pushPaymentKudaUrl = `${apiRoot}/stores/transactions/pushPaymentRequestKuda/`; /* + storeID */

export const fetchCustomerAllTransactionsUrl = `${apiRoot}/stores/transactions/allCustomerTransactions/`; /* + customerID */

export const returnOneProductUrl = `${apiRoot}/stores/transactions/returnOneProduct/`; /* + storeID */
export const returnAllProductUrl = `${apiRoot}/stores/transactions/returnAllProducts/`; /* + storeID */
export const supplyAllProductUrl = `${apiRoot}/stores/transactions/supplyAllProducts/`; /* + storeID */

export const clearLoanUrl = `${apiRoot}/stores/transactions/clearLoan/`; /* + storeID */
export const clearMultipleLoansUrl = `${apiRoot}/stores/transactions/clearMultipleLoans/`; /* + storeID */

export const extendLoanUrl = `${apiRoot}/stores/transactions/extendLoanDueDate/`; /* + storeID */

export const splitPaymentUrl = `${apiRoot}/stores/transactions/splitPayment/`; /* + storeID */
export const fetchAllGoodsOnLoanUrl = `${apiRoot}/stores/storeQueries/getAllGoodsOnLoan/`; /* + storeID */
export const fetchQueriedTransactionUrl = `${apiRoot}/stores/storeQueries/getAQueriedTransaction/`; /* + transactionID */ /* + storeID */
export const fetchYesterdayTransactionUrl = `${apiRoot}/stores/storeQueries/getYesterdayTransactions/`; /* + storeID */
export const fetchCustomTransactionUrl = `${apiRoot}/stores/storeQueries/getCustomedDateTransactions/`; /* + storeID / startDate /endDate */
export const sendReceiptToEmailUrl = `${apiRoot}/stores/transactions/sendReceiptToEmail/`; /* + storeID */

export const createBookingOrderUrl = `${apiRoot}/bookedOrder/createOrder/`; /* + storeID */
export const fetchBookedQuotationUrl = `${apiRoot}/bookedOrder/fetchQuotations/`; /* + storeID */
export const cancelBookedQuotationUrl = `${apiRoot}/bookedOrder/deleteQuotation/`; /* + storeID + orderID */
export const convertQuotationToSalesUrl = `${apiRoot}/bookedOrder/convertToSalesOrder/`; /* + storeID + bookedOrderID */
export const updateBookedQuotationUrl = `${apiRoot}/bookedOrder/updateQuotation/`; /* + storeID + orderID */

/* Analytics */

export const getAnalyticsDataUrl = `${apiRoot}/user/getAnalyticsData/`; /* + storeID */
export const getCustomAnalyticsDataUrl = `${apiRoot}/user/getCustomAnalyticsData/`; /* + storeID */

/* Advertisement */
export const createAdUrl = `${apiRoot}/stores/advertisement/createAd/`; /* + storeID */
export const getStoreAdUrl = `${apiRoot}/stores/advertisement/getStoreAds/`; /* + storeID */
export const reactivateAdUrl = `${apiRoot}/stores/advertisement/reactivateAd/`; /* + storeID +adID*/

/* warehouse */
export const createWarehouseUrl = `${apiRoot}/warehouse/createWarehouse`;

/* message */

export const getMessageUrl = `${apiRoot}/message/getChatList/`; /* + storeID */

/* recieved order route */

export const getRecievedOrderUrl = `${apiRoot}/stores/receivedOrder/`; /* + storeID */
export const setIsNewOrderToFalseUrl = `${apiRoot}/stores/receivedOrder/setIsNewOrderToFalse/`; /* + receivedOrderID */
export const setProductDeliveryStatusUrl = `${apiRoot}/stores/receivedOrder/setProductDeliveryStatus/`; /* + receivedOrderID / productID */
export const updateOrderStatusUrl = `${apiRoot}/stores/receivedOrder/updateOrderStatus/`; /* + receivedOrderID */
export const updateOrderStatusToQuerryUrl = `${apiRoot}/stores/receivedOrder/updateOrderStatusToQuery/`; /* + receivedOrderID */

/* payout */

export const createPayoutUrl = `${apiRoot}/payout/createPayout/`;
export const editPayOutUrl = `${apiRoot}/payout/editPayout/`;
export const getPayOutUrl = `${apiRoot}/payout/getPayout/`; /* + payoutID */

/* sales record */

export const getSalesRecordUrl = `${apiRoot}/salesRecord/getSalesRecord/`; /* +today || yesterday */
export const getCustomSalesRecordUrl = `${apiRoot}/salesRecord/getCustomSalesRecord/`; /* + startDate / endDate */

/* dashboard */

export const getDashboardUrl = `${apiRoot}/dashboard/getDashboard/`; /* + today || yesterday || custom */

export const getCustomDashboardUrl = `${apiRoot}/dashboard/getCustomDashboard/`; /* + daily || monthly */

/* store utilities */

export const registerStoresDailyCheckUrl = `${apiRoot}/stores/registerDailySalesCheck/`; /* + storeID */

/* utils endpoints */

export const genInvoiceUrl = `${apiRoot}/stores/generateReceipt/`; /* + trans ID */

/* verifications */

export const smsVerificationUrl = `${apiRoot}/smsVerification/sendCode/`;

export const verifyUserUrl = `${apiRoot}/smsVerification/verifyUser/`;

/* generate Logo and Images */

export const generateLogoUrl = `${apiRoot}/genAi/generateLogo`;
export const generateAdUrl = `${apiRoot}/genAi/generateAdvertImage`;
